import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {useIntl} from 'react-intl';
import {UnauthorizedPage} from '@te-digi/styleguide';
import PropTypes from 'prop-types';
import getUserState from '../ducks/user/selectors/getUserState';
import {USER_STATUS} from '../ducks/user/constants';
import {fetchUser} from '../ducks/user/actionCreators';
import LoadingIndicator from './LoadingIndicator';

const EnsureUser = ({children, fetchUser: fetchUserConnected, userState}) => {
  const intl = useIntl();

  useEffect(() => {
    fetchUserConnected();
  }, [fetchUserConnected]);

  const userOk = userState === USER_STATUS.OK;
  // Prevent flash of "no user" message while loading
  if (
    userState === USER_STATUS.LOADING ||
    userState === USER_STATUS.NOT_AVAILABLE
  ) {
    return <LoadingIndicator center />;
  }

  return (
    <>
      {userOk ? (
        children
      ) : (
        <UnauthorizedPage
          heading={intl.formatMessage({
            id: 'authorization_invalid'
          })}
          content={<></>}
        />
      )}
    </>
  );
};

EnsureUser.propTypes = {
  children: PropTypes.node.isRequired,
  fetchUser: PropTypes.func.isRequired,
  userState: PropTypes.string.isRequired
};

export default connect(
  state => ({
    userState: getUserState(state)
  }),
  {fetchUser}
)(EnsureUser);
